import { TileCategory } from "@/models/board";

const categories: Readonly<Record<string, TileCategory>> = {
  prideRed: new TileCategory({ colorClass: "bg-pride-red" }),
  prideOrange: new TileCategory({ colorClass: "bg-pride-orange" }),
  prideYellow: new TileCategory({ colorClass: "bg-pride-yellow" }),
  prideGreen: new TileCategory({ colorClass: "bg-pride-green" }),
  prideBlue: new TileCategory({ colorClass: "bg-pride-blue" }),
  pridePurple: new TileCategory({ colorClass: "bg-pride-purple" }),
};

export default categories;
